import type { SVGProps } from 'react';
import * as React from 'react';

const NwdIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={40} height={44} viewBox="0 0 40 44" fill="none" aria-hidden="true" {...props}>
    <g id="file-icon/nwd">
      <g id="Vector" filter="url(#filter0_dd_3816_38045)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L35.3334 10.1111V38.3333C35.3334 39.8061 34.1505 41 32.6777 41C27.0142 41 13.7443 41 7.32677 41C5.85401 41 4.66675 39.82 4.66675 38.3473C4.66675 30.3468 4.66675 10.7752 4.66675 3.6498C4.66675 2.17704 5.86066 1 7.33341 1H26.2223Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L35.3334 10.1111V38.3333C35.3334 39.8061 34.1505 41 32.6777 41C27.0142 41 13.7443 41 7.32677 41C5.85401 41 4.66675 39.82 4.66675 38.3473C4.66675 30.3468 4.66675 10.7752 4.66675 3.6498C4.66675 2.17704 5.86066 1 7.33341 1H26.2223Z"
          fill="url(#paint0_radial_3816_38045)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L26.2223 7.44444C26.2223 8.9172 27.4162 10.1111 28.889 10.1111L35.3334 10.1111L26.2223 1Z"
          fill="#F3F4F6"
        />
      </g>
      <g id="Vector_2">
        <path
          d="M28.5333 14.1111H24.711C24.3288 14.4933 24.1377 14.6844 23.7555 15.0666V22.95C23.7555 22.95 23.8033 23.8577 23.421 23.9533C23.0388 24.0489 22.6088 23.4278 22.6088 23.4278L15.4421 14.1111H11.3333V33.2222H15.1555C15.5377 32.84 15.7288 32.6489 16.111 32.2666C16.111 32.2666 15.9677 24.7655 16.7321 24.7177C18.2133 24.6222 24.1377 33.2222 24.1377 33.2222H28.5333V14.1111Z"
          fill="#1976D2"
        />
        <path
          d="M23.7561 15.0665V22.9498C23.7561 22.9498 23.8039 23.8576 23.4216 23.9531C23.0394 24.0487 22.6094 23.4276 22.6094 23.4276L19.1216 18.8887C18.8828 20.5131 18.7872 22.3765 18.7872 24.2876C18.7872 25.0043 18.7872 25.6731 18.835 26.342C21.0805 28.7787 24.1383 33.222 24.1383 33.222H24.9505C25.6194 30.9287 26.0494 27.7754 26.0494 24.2876C26.0494 20.1787 25.4761 16.5476 24.5683 14.2543C24.2816 14.5409 24.0905 14.732 23.7561 15.0665Z"
          fill="#2770AA"
        />
        <path
          d="M23.374 23.9531C22.9918 24.0009 22.6094 23.4276 22.6094 23.4276L19.6951 19.6531C18.5007 18.6975 24.664 30.7375 25.524 30.0209C26.384 29.352 25.1895 26.2464 23.4695 24.0487C23.4695 24.0487 23.4218 24.0009 23.374 23.9531Z"
          fill="#3A95CC"
        />
        <path
          d="M16.7324 24.7177C18.2135 24.6222 24.1379 33.2222 24.1379 33.2222H28.5335V32.8877L19.7424 19.7011L15.4424 14.1111H11.6679C12.3368 19.7489 13.3879 26.5333 15.1557 33.2222C15.5379 32.84 15.729 32.6489 16.1113 32.2666C16.1113 32.2666 15.9679 24.7655 16.7324 24.7177Z"
          fill="#1E88E5"
        />
        <path
          d="M16.0162 19.1756C13.9618 19.7011 15.1562 33.2222 15.1562 33.2222C15.5384 32.84 15.7295 32.6489 16.1118 32.2667C16.1118 32.2667 15.9684 24.7656 16.7329 24.7178C18.214 24.6222 24.1384 33.2222 24.1384 33.2222C24.1384 33.2222 17.8795 18.6978 16.0162 19.1756Z"
          fill="#2559AA"
        />
      </g>
      <g id="border">
        <path
          d="M7.33691 1.5H26.0186L34.8369 10.3184V38.333C34.8369 39.5323 33.8746 40.5 32.6807 40.5H7.33008C6.20656 40.5 5.29068 39.6581 5.18066 38.5684L5.16992 38.3477V3.64941C5.17013 2.4571 6.13628 1.5 7.33691 1.5Z"
          stroke="black"
          strokeOpacity={0.06}
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_dd_3816_38045"
        x={2.66675}
        y={0}
        width={34.6667}
        height={44}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3816_38045" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_3816_38045" result="effect2_dropShadow_3816_38045" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3816_38045" result="shape" />
      </filter>
      <radialGradient
        id="paint0_radial_3816_38045"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(20.0001 0.999999) rotate(90) scale(40 40.1825)"
      >
        <stop offset={0.297418} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.03} />
      </radialGradient>
    </defs>
  </svg>
);
export default NwdIcon;
